import { useEffect, useMemo, useState } from 'react'

import { Box, Button, InputAdornment, Popover, TextField } from '@mui/material'

import { AVAILABLE_INTERVALS } from '../constants'
import { calculateDateRanges } from '../utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} [props.data]
 * @param {Object} [props.data.interval]
 * @param {React.Node} [props.data.anchor]
 * @param {Function} props.onClose
 * @param {Function} props.onChange
 * @param {string} [props.goLiveDate]
 * @param {boolean} props.disabled
 */
export default function RangeInputPopover({
  data,
  onClose,
  onChange,
  goLiveDate,
  disabled,
}) {
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    if (data) {
      setInputValue(data.interval.range ?? data.interval.defaultRange)
    }
  }, [data])

  const adornmentText = useMemo(() => {
    if (data) {
      if (data.interval.id === AVAILABLE_INTERVALS.monthly.id) {
        return 'months'
      }
      if (data.interval.id === AVAILABLE_INTERVALS.weekly.id) {
        return 'weeks'
      }
      return ''
    }
    return ''
  }, [data])

  const isError = !inputValue || (inputValue && inputValue < 1)

  return (
    <Popover
      open={!!data}
      onClose={onClose}
      anchorEl={data?.anchor}
      anchorOrigin={{
        vertical: data?.isEdit ? 40 : 50,
        horizontal: 'center',
      }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Box display="flex" gap={1} p={1}>
        <TextField
          error={isError}
          size="small"
          placeholder="_____"
          disabled={disabled}
          value={inputValue}
          onChange={(event) => setInputValue(event.target.value)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">{adornmentText}</InputAdornment>
              ),
            },
            htmlInput: { inputMode: 'numeric', maxLength: 3 },
          }}
          sx={{ width: 140 }}
        />
        <Button
          size="small"
          disabled={isError}
          onClick={() => {
            const numericValue = Number(inputValue)
            const intervalData = { ...data.interval, range: numericValue }

            const ranges = calculateDateRanges(intervalData, goLiveDate)
            onChange({ ...intervalData, ranges })
            onClose()
          }}
        >
          Submit
        </Button>
      </Box>
    </Popover>
  )
}
